import { ITableField } from '../../../../shared/Table'
import { IUser } from '../../../AuthProvider/user.api'

const usersTableFields: Array<ITableField<IUser, keyof IUser>> = [
  {
    key: 'id',
    header: 'ID',
    getter: (answer) => answer.id || '-',
    sortGetter: (answer) => answer.id || '-',
    width: '100px',
  },
  {
    key: 'email',
    header: 'email',
    getter: (answer) => answer.email || '-',
    sortGetter: (answer) => answer.email || '-',
    width: '600px',
  },
]

export default usersTableFields
